<template>
    <b-modal :no-close-on-backdrop="true" :title="Core.Definition.getDefinition('Formulaire')" :hide-footer="true" v-model="dataShow">
        <DynamicForm
                ref="dynamicForm"
                v-model="dataId"
                @onInit="onInit"
                @onInitSuccess="onInitSuccess"
                @onRequestSuccess="onRequestSuccess"
                @onSaveSuccess="onSaveSuccess"
                :ignoreRouteParamId="true"
                getRoot="/binder-form"
                saveRoot="/binder-form"
                :formStructure="dataFormStructures.form">
            <slot slot="beforeFormButtons">
                <slot name="formButtons">
                </slot>
            </slot>
        </DynamicForm>
    </b-modal>
</template>

<script>
    import DynamicForm from './DynamicForm'
    export default {
        name: 'ModalBinderForm',
        components: {
            DynamicForm
        },
        props: {
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            },
            id: {
                set(val) {
                    this.dataId = val
                },
                get() {
                    return this.dataId
                }
            },
            binderId: {
                set(val) {
                    this.dataBinderId = val
                },
                get() {
                    return this.dataBinderId
                }
            },
            binderIndexId: {
                set(val) {
                    this.dataBinderIndexId = val
                },
                get() {
                    return this.dataBinderIndexId
                }
            },
            title: {
                set(val) {
                    this.dataTitle = val
                },
                get() {
                    return this.dataTitle
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataShow: false,
                dataId: '',
                dataBinderId: '',
                dataTitle: '',
                dataBinderIndexId: '',
                dataTemplates: [],
                dataFormStructures: {
                    form: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                options: {
                                                    class: 'card-no-body'
                                                },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'position'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'city'
                                                                    }
                                                                ]
                                                            },
                                                            {}
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'formTemplateId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: Core.Value.typeText,
                                label: Core.Definition.getDefinition('Titre'),
                                value: ''
                            },
                            {
                                id: 'description',
                                type: Core.Value.typeLongText,
                                label: Core.Definition.getDefinition('Description'),
                                value: ''
                            },
                            {
                                id: 'position',
                                type: 'select',
                                label: Core.Definition.getDefinition('Position'),
                                description: Core.Definition.getDefinition(''),
                                value: null,
                                required: true,
                                onSelect: function(value, form, fieldRefs) {}
                            },
                            {
                                id: 'city',
                                type: 'select',
                                label: Core.Definition.getDefinition('Ville'),
                                description: Core.Definition.getDefinition(''),
                                required: false,
                                onSelect: this.onSelectCity,
                                options: [
                                    {
                                        label: 'Montréal',
                                        value: 'montreal'
                                    },
                                    {
                                        label: 'Québec',
                                        value: 'quebec'
                                    }
                                ]
                            },
                            {
                                id: 'formTemplateId',
                                type: 'select',
                                label: Core.Definition.getDefinition('Modèle'),
                                description: Core.Definition.getDefinition(''),
                                required: true,
                                onSelect: function(value, form, fieldRefs) {}
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onSelectCity(value, form, fieldRefs) {
                if(!Core.Validation.isId(this.dataId)) {
                    this.$refs.dynamicForm.$refs.form.fieldRefs['formTemplateId'].setOptions([])
                    this.$refs.dynamicForm.$refs.form.fieldRefs['formTemplateId'].dataValue = null
                    if(value !== null && value.value !== undefined) {
                        let city = value.value
                        let cities = []
                        for(let template in this.dataTemplates) {
                            template = this.dataTemplates[template]
                            if (template.data.city !== null) {
                                let templateCity = template.data.city.split(',')
                                if (templateCity.includes(city)) {
                                    cities.push(template)
                                }
                            } else {
                                cities.push(template)
                            }
                        }
                        this.$refs.dynamicForm.$refs.form.fieldRefs['formTemplateId'].setOptions(cities)
                    }
                }
            },
            onInit() {
                this.$refs.dynamicForm.$refs.request.addArg('binderId', this.dataBinderId)
                this.$refs.dynamicForm.$refs.request.addArg('binderIndexId', this.dataBinderIndexId)

            },
            onRequestSuccess(data, method) {
                if (data.selectOptions !== undefined && data.selectOptions.formTemplateId !== undefined) {
                    this.dataTemplates = data.selectOptions.formTemplateId
                    if(!Core.Validation.isId(this.dataId)) {
                        this.$refs.dynamicForm.$refs.form.fieldRefs['formTemplateId'].setOptions([])
                    }
                }
                if(Core.Validation.isId(this.dataId)) {
                    this.$refs.dynamicForm.$refs.form.fieldRefs['city'].dataIsVisible = false
                }
            },
            onInitSuccess(data) {
                if (data.title !== undefined) {
                    this.$refs.dynamicForm.$refs.form.fieldRefs['title'].dataValue = data.title
                }
                if (data.selectOptions.position !== undefined) {
                    let position = data.selectOptions.position[data.selectOptions.position.length - 1]
                    this.$refs.dynamicForm.$refs.form.fieldRefs['position'].dataValue = position
                }
                this.$emit('onInitSuccess', data)
            },
            onSaveSuccess(data) {
                this.$emit('onSaveSuccess', data)
            }
        }
    }
</script>
